// Reducer for rediscover actions

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaulSubscriberState = {
  overview: { ...DefaultState },
  genreTitle: { ...DefaultState },
  byNetwork: {},
  selectedNetwork: null,
  selectedNetworkType: null,
  selectedMetricDate: '',
  byMetricDate: {}
}
export const DefaultOverviewState = {
  ...DefaultState
}

export const subscriberOverviewDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultOverviewState,
  actionRequest: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW,
  actionFailure: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW,
  actionInvalidate: ActionTypes.INVALIDATE_SUBSCRIBER_OVERVIEW
})

export const subscriberGenreTitleDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultOverviewState,
  actionRequest: ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE,
  actionFailure: ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SUBSCRIBER_GENRE_TITLE,
  actionInvalidate: ActionTypes.INVALIDATE_SUBSCRIBER_GENRE_TITLE
})

export const subscriberWhatsNewDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultOverviewState,
  actionRequest: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR,
  actionFailure: ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW_CALENDAR,
  actionInvalidate: ActionTypes.INVALIDATE_SUBSCRIBER_OVERVIEW_CALENDAR
})

export const whatsNewByNetwork = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR:
    case ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW_CALENDAR:
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR_FAILURE:
    case ActionTypes.INVALIDATE_SUBSCRIBER_OVERVIEW_CALENDAR:
      return {
        ...state,
        whatsNew: subscriberWhatsNewDetails(state.whatsNew, action)
      }
  }
}

export const overviewByMetricDate = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW:
    case ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW:
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_FAILURE:
    case ActionTypes.INVALIDATE_SUBSCRIBER_OVERVIEW:
      return {
        ...state,
        overview: subscriberOverviewDetails(state.details, action)
      }
    default:
      return state
    }
}

export const genreTitleByMetricDate = (state = {}, action) => {
  console.log(state, action)
  switch (action.type) {
    case ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE:
    case ActionTypes.RECEIVE_SUBSCRIBER_GENRE_TITLE:
    case ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE_FAILURE:
    case ActionTypes.INVALIDATE_SUBSCRIBER_GENRE_TITLE:
      return {
        ...state,
        genreTitle: subscriberGenreTitleDetails(state.details, action)
      }
    default:
      return state
    }
}

export const subscriber = (state = DefaulSubscriberState, action) => {
  switch (action.type) {
    case ActionTypes.SUBSCRIBERS_SELECTED_QUARTER:
      return {
        ...state,
        selectedMetricDate: action.metricDate
      }
    case ActionTypes.SUBSCRIBER_SELECTED_NETWORK:
      return {
        ...state,
        selectedNetwork: action.network
      }
    case ActionTypes.SUBSCRIBER_SELECTED_NETWORK_TYPE:
      return {
        ...state,
        selectedNetworkType: action.networkType
      }
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW:
    case ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW:
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_FAILURE:
    case ActionTypes.INVALIDATE_SUBSCRIBER_OVERVIEW:
      if (action.metricDate) {
        return {
          ...state,
          selectedMetricDate: action.metricDate,
          byMetricDate: {
            ...state.byMetricDate,
            [action.metricDate]: overviewByMetricDate(state.byMetricDate[action.metricDate], action)
          }
        }
      } else {
        console.warn('Catalog Overview action fired without a metric date:', action)
        return state
      }
    case ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE:
    case ActionTypes.RECEIVE_SUBSCRIBER_GENRE_TITLE:
    case ActionTypes.REQUEST_SUBSCRIBER_GENRE_TITLE_FAILURE:
    case ActionTypes.INVALIDATE_SUBSCRIBER_GENRE_TITLE:
      if (action.metricDate) {
        return {
          ...state,
          selectedMetricDate: action.metricDate,
          byMetricDate: {
            ...state.byMetricDate,
            [action.metricDate]: genreTitleByMetricDate(state.byMetricDate[action.metricDate], action)
          }
        }
      } else {
        console.warn('Catalog Genre Title action fired without a metric date:', action)
        return state
      }
      // return {
      //   ...state,
      //   genreTitle: subscriberGenreTitleDetails(state.genreTitle, action)
      // }
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR:
    case ActionTypes.RECEIVE_SUBSCRIBER_OVERVIEW_CALENDAR:
    case ActionTypes.REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR_FAILURE:
    case ActionTypes.INVALIDATE_SUBSCRIBER_OVERVIEW_CALENDAR:
      if (action.network) {
        return {
          ...state,
          byNetwork: {
            ...state.byNetwork,
            [action.network]: whatsNewByNetwork(state.byNetwork[action.network], action)
          }
        }
      } else {
        console.warn('Topic action fired without a topic id:', action)
        return state
      }
    default:
      return state
    }
}